module.exports = "/static/assets/38a70367a21e2f1fb15aa59b7d367450.svg";